import { exchangeApi } from '@api/index';
import { useQuery } from '@hooks/useQuery';
import { QUERIES } from '@query/queries';

export const useBurnStatusQuery = () => {
  return useQuery([QUERIES.BURN_STATUS], () => exchangeApi.getCoinBurnStatus());
};
